module.exports = __webpack_public_path__ + "static/media/10.3b0661f3.mp3";